<div class="type-list px-3 py-1 custom-scroll-height-2" id="scrollContainerElement">
  @for(driver of driversList ; track $index){
  <div class="py-3 border-bottom">
    <div class="d-flex align-items-start justify-content-between c-pointer" (click)="onDriverDetails(driver)">
      <div class="service-type d-flex align-items-center">
        <img [src]="driver.imageUrl ? helper.IMAGE_URL + driver.imageUrl : helper.DefaultImages.DefaultUserImage"
          alt="driver_profile" class="driver-image" (error)="handleImageError($event)" />
        <div class="type-name ms-3">
          @if(driver.status == helper.DriverStatus.IN_BOOKING && driver.bookingDetails[0]){
          <p class="mb-0 text-dark-color">{{ "heading-title.booking-no" | translate | uppercase }} {{
            driver.bookingDetails }}</p>
          }
          <h6 class="mb-0">{{ driver.firstName }} {{ driver.lastName }}</h6>
          <p class="mb-0 text-dark-color">
            @if(driver?.vehicleBrandDetail){
            {{ driver?.vehicleBrandDetail?.name | translatedName : helper.cuurentLang }} |
            }
            @if(driver?.vehicleModelDetail){
            {{ driver?.vehicleModelDetail?.name | translatedName : helper.cuurentLang }} |
            }
            @if(driver.vehicleDetail){
            {{ driver.vehicleDetail?.color }} | {{ driver.vehicleDetail?.plateNo }}
            }
          </p>
          @if(driver.status == helper.DriverStatus.AVAILABLE){
          <p class="mb-1">
            {{ "label-title.last-booking" | translate }} :
            {{ 
              helper.moment(driver.lastBookingAt)
              .tz(helper.displayTimezone)
              .format(helper.DATE_FORMAT.DD_MM_YY) 
            }} 
            {{ 
              helper.moment(driver.lastBookingAt)
              .tz(helper.displayTimezone)
              .format(timeFormat ?? helper.TimeFormatEnum.TwentyFourHour) 
            }}
          </p>
        } @if(driver.status == helper.DriverStatus.APPROVE){
          <p class="mb-1">
            {{ "label-title.last-active" | translate }} :
            {{ 
              helper.moment(driver.lastActiveAt)
              .tz(helper.displayTimezone)
              .format(helper.DATE_FORMAT.DD_MM_YY) 
            }} 
            {{ 
              helper.moment(driver.lastActiveAt)
              .tz(helper.displayTimezone)
              .format(timeFormat ?? helper.TimeFormatEnum.TwentyFourHour) 
            }}
          </p>
          }
        </div>
      </div>
      <div class="ratings">
      @if(driver?.rate){
        <span class="badge bg-success mx-1">
          <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 9 9" fill="none"
            style="margin-top: -2px">
            <path
              d="M3.43234 2.028C3.90747 1.176 4.14484 0.75 4.49997 0.75C4.85509 0.75 5.09247 1.176 5.56759 2.028L5.69059 2.2485C5.82559 2.49075 5.89309 2.61187 5.99809 2.69175C6.10309 2.77162 6.23434 2.80125 6.49684 2.8605L6.73534 2.9145C7.65784 3.12337 8.11872 3.22762 8.22859 3.5805C8.33809 3.933 8.02384 4.30087 7.39497 5.03625L7.23222 5.22637C7.05372 5.43525 6.96409 5.53987 6.92397 5.66887C6.88384 5.79825 6.89734 5.93775 6.92434 6.21637L6.94909 6.47025C7.04397 7.45162 7.09159 7.94212 6.80434 8.16C6.51709 8.37825 6.08509 8.17912 5.22184 7.78162L4.99797 7.67887C4.75272 7.56562 4.63009 7.50937 4.49997 7.50937C4.36984 7.50937 4.24722 7.56562 4.00159 7.67887L3.77847 7.78162C2.91484 8.17912 2.48284 8.37787 2.19597 8.16037C1.90834 7.94212 1.95597 7.45162 2.05084 6.47025L2.07559 6.21675C2.10259 5.93775 2.11609 5.79825 2.07559 5.66925C2.03584 5.53987 1.94622 5.43525 1.76772 5.22675L1.60497 5.03625C0.976091 4.30125 0.661841 3.93337 0.771341 3.5805C0.881216 3.22762 1.34247 3.123 2.26497 2.9145L2.50347 2.8605C2.76559 2.80125 2.89647 2.77162 3.00184 2.69175C3.10684 2.61187 3.17434 2.49075 3.30934 2.2485L3.43234 2.028Z"
              fill="white" />
          </svg>
          {{ (driver?.rate).toFixed(helper.fixedNumber) }}</span>
        }
        <span class="badge bg-warning" (click)="openMassNotificationModal(driver)">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#ffffff"  width="11" height="11"version="1.1" id="Capa_1" viewBox="0 0 495.003 495.003" xml:space="preserve">
            <g id="XMLID_51_">
              <path id="XMLID_53_" d="M164.711,456.687c0,2.966,1.647,5.686,4.266,7.072c2.617,1.385,5.799,1.207,8.245-0.468l55.09-37.616   l-67.6-32.22V456.687z"/>
              <path id="XMLID_52_" d="M492.431,32.443c-1.513-1.395-3.466-2.125-5.44-2.125c-1.19,0-2.377,0.264-3.5,0.816L7.905,264.422   c-4.861,2.389-7.937,7.353-7.904,12.783c0.033,5.423,3.161,10.353,8.057,12.689l125.342,59.724l250.62-205.99L164.455,364.414   l156.145,74.4c1.918,0.919,4.012,1.376,6.084,1.376c1.768,0,3.519-0.322,5.186-0.977c3.637-1.438,6.527-4.318,7.97-7.956   L494.436,41.257C495.66,38.188,494.862,34.679,492.431,32.443z"/>
            </g>
            </svg>
        </span>
      </div>
    </div>
  </div>
  }@empty {
  <div class="">
    <p class="py-3 text-center font-weight-medium">{{ "label-title.no-driver-found" | translate }}</p>
  </div>
  }
</div>


<ng-template #massNotificationModal let-modal>
  <div class="offcanvas-header border-bottom">
    <h4 class="modal-title">
      {{ "heading-title.send-notification" | translate }} ({{ driver.firstName }} {{ driver.lastName }} #{{ driver.uniqueId }}) 
    </h4>
    <button type="button" class="btn-close" (click)="closeModal()"></button>
  </div>
  <div class="offcanvas-body">
    <form [formGroup]="massNotificationForm">
      <div class="row g-3">
        <div class="col-12">
          <label for="mass-notification-title" class="form-label">{{ "label-title.title" | translate }}</label>
          <input id="mass-notification-title" type="text" class="form-control" formControlName="title" (keypress)="helper.spaceValidation($event)" />
          @if(massNotificationForm.get('title')?.errors && massNotificationForm.get('title')?.touched && massNotificationForm.get('title')?.errors?.['required']){
          <div class="invalid-message">
            <p class="m-0">{{ "label-title.title" | translate }} {{ "label-title.is-required" | translate }}</p>
          </div>
          }
        </div>
        <div class="col-12">
          <label for="mass-notification-message" class="form-label">{{ "label-title.message" | translate }}</label>
          <textarea id="mass-notification-message" class="form-control" formControlName="message" (keypress)="helper.spaceValidation($event)"></textarea>
          @if(massNotificationForm.get('message')?.errors && massNotificationForm.get('message')?.touched && massNotificationForm.get('message')?.errors?.['required']){
          <div class="invalid-message">
            <p class="m-0">{{ "label-title.message" | translate }} {{ "label-title.is-required" | translate }}</p>
          </div>
          }
        </div>
        <div class="col-12">
          <h5 class="fs-14 mb-2">{{ "heading-title.notification-image" | translate }}</h5>
          <div class="">
            <div class="position-relative d-inline-block">
              <div class="position-absolute top-100 start-100 translate-middle">
                <label for="vehicle-type-map-pin-image" class="mb-0" placement="right" ngbTooltip="{{ 'label-title.select-image' | translate }}">
                  <span [hidden]="true">Some text written due to sonarlint warning</span>
                  <div class="avatar-xs">
                    <div class="avatar-title bg-light border rounded-circle text-muted cursor-pointer">
                      <em class="ri-image-fill"></em>
                    </div>
                  </div>
                </label>
                <input class="form-control visually-hidden" id="vehicle-type-map-pin-image" type="file" (change)="onSelectNotificationImageFile($event)" accept="image/*" />
              </div>
              <div class="vehicle-type-image-box-dimension">
                <div class="avatar-title bg-light rounded">
                  <img
                    [src]="notificationImageurl ? notificationImageurl : ''"
                    alt=""
                    id="product-img"
                    class="vehicle-type-image-width map-pin-image"
                    [ngClass]="{ 'vehicle-type-image-height': notificationImageurl }"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="offcanvas-footer border-top d-flex justify-content-end">
    <button
      id="send-mass-notification"
      class="btn btn-secondary btn-load d-flex align-items-center justify-content-center"
      (click)="sendMassNotification()"
      [ngClass]="{ 'pointer-events-none': helper.showBtnLoader[1] }"
    >
      <span class="d-flex align-items-center">
        @if (helper.showBtnLoader[1]) {
        <span class="spinner-border flex-shrink-0">
          <span class="visually-hidden"></span>
        </span>
        } @else {
        <span class="flex-grow-1" [ngClass]="{ 'ms-2': helper.showBtnLoader[1] }">
          {{ "button-title.save" | translate }}
        </span>
        }
      </span>
    </button>
  </div>
</ng-template>